import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = {
  id: "menuButton",
  class: "btn btn-default dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-offset": "-90,1"
}
const _hoisted_3 = {
  class: "dropdown-menu",
  "aria-labelledby": "menuButton"
}
const _hoisted_4 = { class: "dropdown-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-qrcode me-1" }, null, -1)
const _hoisted_6 = { class: "dropdown-item" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrows-alt me-1" }, null, -1)

import { useRoute, useRouter } from "vue-router";

import { ContentsUrl } from "../../../utils/ContentsUrl";
import { SessionUser } from "../../../utils/SessionUser";
import { DialogHandler } from "../../dialog/DialogHandler";
import { translation } from "../../../lang/Translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileMenuExecButtons',
  setup(__props) {

const t = translation;
const route = useRoute();

// ルーティングとプロジェクトID
const project_id = route.params.project_id as string;
const user_id = SessionUser.instance.userId;

/**
 * タイトル・ラベル
 */
const qrCodeMenuButtonTitle = t.to("QR コード", "qr_code");
const openOtherTabMenuButtonTitle = t.to("別タブで開く","open_tab");
const contentsUrl = ContentsUrl.instance.getUrl(project_id, user_id);
const openQr = () => {
  DialogHandler.showQRDialog();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, _toDisplayString(_unref(t).to("ファイル", "file")), 1),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: openQr
        }, [
          _hoisted_5,
          _createTextVNode(),
          _createElementVNode("span", null, _toDisplayString(_unref(qrCodeMenuButtonTitle)), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("a", {
          class: "btn btn-default",
          target: "_blank",
          href: _unref(contentsUrl)
        }, [
          _hoisted_8,
          _createElementVNode("span", null, _toDisplayString(_unref(openOtherTabMenuButtonTitle)), 1)
        ], 8, _hoisted_7)
      ])
    ])
  ]))
}
}

})